<script setup>
import { computed } from 'vue';
import { format, isValid, parseISO } from 'date-fns';
import DateTimePicker from 'dashboard/components/ui/DateTimePicker.vue';
import ptBR from 'vue-datepicker-next/locale/pt-br.es';

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, required: true },
  withTime: { type: Boolean, default: false },
});
const emit = defineEmits(['update:modelValue']);
const timeHint =
  'Escolha a data e depois o horário. Clique na data para voltar ao calendário.';
const selectedDate = computed(() => {
  const date = parseISO(props.modelValue);
  return isValid(date) ? date : null;
});
function updateDate(date) {
  if (!date || !isValid(date)) {
    emit('update:modelValue', '');
    return;
  }
  emit(
    'update:modelValue',
    props.withTime ? date.toISOString() : format(date, 'yyyy-MM-dd')
  );
}
</script>

<template>
  <div class="proposal-date-field flex min-w-0 flex-col gap-1">
    <label class="mb-0.5 text-heading-3 text-n-slate-12">{{ label }}</label>
    <DateTimePicker
      :value="selectedDate"
      :picker-type="withTime ? 'datetime' : 'date'"
      :format="withTime ? 'DD/MM/YYYY HH:mm' : 'DD/MM/YYYY'"
      :placeholder="withTime ? 'Selecione data e horário' : 'Selecione a data'"
      :locale="ptBR"
      confirm-text="Aplicar"
      :disable-past="false"
      :append-to-body="false"
      clearable
      @change="updateDate"
    />
    <p v-if="withTime" class="mb-0 mt-1 text-xs text-n-slate-11">
      {{ timeHint }}
    </p>
  </div>
</template>

<style scoped>
:deep(.mx-datepicker) {
  width: 100%;
}

:deep(.mx-datepicker-main) {
  font-family: inherit;
  @apply rounded-xl border border-n-weak bg-n-solid-1 text-n-slate-12 shadow-lg;
}
:deep(.mx-calendar-header),
:deep(.mx-time-header),
:deep(.mx-btn) {
  @apply text-n-slate-12;
}
:deep(.mx-time-column + .mx-time-column) {
  @apply border-n-weak;
}
:deep(.mx-datepicker-footer) {
  @apply border-0 border-t border-solid border-n-weak px-3 py-2;
}
:deep(.mx-datepicker-btn-confirm) {
  @apply rounded-lg border-0 bg-n-brand px-4 py-2 text-sm font-medium text-white;
}
:deep(.mx-time-item) {
  @apply text-n-slate-11;
}
:deep(.mx-time-item.active) {
  @apply rounded-md bg-n-alpha-2 font-semibold text-n-blue-11;
}
</style>
